import { render, staticRenderFns } from "./idCard.vue?vue&type=template&id=56686f7c&scoped=true"
import script from "./idCard.vue?vue&type=script&lang=js"
export * from "./idCard.vue?vue&type=script&lang=js"
import style0 from "./idCard.vue?vue&type=style&index=0&id=56686f7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56686f7c",
  null
  
)

export default component.exports